<style scoped></style>
<template>
    <div :style="options.title ? 'padding: 20px;' : ''">
        <div class="jcsb" style="margin-bottom: 20px" v-if="!!options.title">
            <div style="display: flex; align-items: center">
                <div style="font-size: 24px; font-weight: bold">{{ options.title }}</div>
                <slot name="head"></slot>
            </div>
        </div>
        <!-- prettier-ignore -->
        <div class="jcsb">
            <div>
                <Query
                    :options="options.query"
                    @on-query="
                        query = $event;
                        page.current = 1;
                        loadData()
                    "
                    @on-load="
                        query = $event;
                        page.current = 1;
                        loadData()
                    "></Query>
            </div>
            <div style="margin-bottom: 10px">
                <slot name="headright"></slot>
            </div>
        </div>
        <slot name="head" v-if="!options.title"></slot>
        <slot name="body"></slot>
        <div style="height: 10px"></div>
        <Table ref="sheet" border fixed-shadow="auto" :columns="columns" :show-summary="options.summary ? true : false" :summary-method="options.summaryMethod" :loading="loading" :data="datas" @on-select="itemSelected" @on-select-cancel="itemSelectedCancel" @on-select-all="allSelected" @on-select-all-cancel="allSelectedCancel" @on-sort-change="sortChanged"></Table>
        <div class="jcsb">
            <div style="padding-top: 10px">
                <div>
                    <!-- prettier-ignore -->
                    <Tag
                        v-if="query.selections"
                        closable
                        @on-close="
                            query.selections = null;
                            loadData();
                        ">
                        只看已选的 <span style="color: #20bf64">{{ query.selections.length }}</span> 项</Tag
                    >
                    <div v-else-if="selections.length" style="margin-bottom: 10px; display: flex; align-items: center">
                        已选<span style="color: #20bf64; margin: 0 4px">{{ selections.length }}</span
                        >项
                        <div @click="showSelections" style="color: #20bf64; margin-left: 10px" class="hover">查看</div>
                        <div @click="clearSelections" style="color: #20bf64; margin-left: 10px" class="hover">取消选择</div>
                        <div @click="selectAllPage" style="color: #20bf64; margin-left: 10px" class="hover">全选</div>
                    </div>
                </div>
                <div style="display: flex; align-items: center">
                    <div v-if="options.exportable && selections.length < total" @click="toExport('all')" style="color: #20bf64; margin-right: 10px" class="hover">导出全部{{ total }}条数据</div>
                    <div v-if="options.exportable && selections.length" @click="toExport('selection')" style="color: #20bf64; margin-right: 10px" class="hover">导出选中的{{ selections.length }}条数据</div>
                    <slot name="foot"></slot>
                </div>
                <slot name="batchops" v-if="selections.length"></slot>
            </div>
            <div>
                <Page v-if="total > page.size || page.size > 10" placement="top" :page-size-opts="[10, 20, 50, 100, 200]" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" @on-page-size-change="pageSizeChanged" show-sizer show-total style="margin-top: 10px"></Page>
            </div>
        </div>
    </div>
</template>
<script>
    import Query from '@/components/common/Query.vue'
    export default {
        components: {
            Query,
        },
        props: {
            title: String,
            options: {
                type: Object,
                default: {},
            },
            // columns: {
            //     type: Array,
            //     default: []
            // },
            // fields: {
            //     type: Object,
            // },
            // querys: {
            //     type: Array,
            // }
        },
        data() {
            return {
                session: this.$store.session,
                selections: [],
                loading: false,
                total: 0,
                page: {
                    size: 10,
                    current: 1,
                },
                query: { init: true },
                datas: [],
                columns: [],
            }
        },
        // watch: {
        //     options(value) {
        //         this.options = value
        //         this.init()
        //     }
        // },
        mounted() {
            this.init()
        },
        methods: {
            sortChanged({ column, key, order }) {
                if (column && key && (order == 'asc' || order == 'desc')) {
                    let sort = {}
                    sort[key] = order == 'asc' ? 1 : -1
                    this.query.sort = sort
                } else {
                    this.query.sort = null
                }
                this.loadData()
            },
            showSelections() {
                this.query.selections = this.selections.map((item) => {
                    return { _id: item._id }
                })
                this.page.current = 1
                this.loadData()
            },
            clearSelections() {
                this.selections = []
                let datas = []
                for (let item of this.datas) {
                    item._checked = false
                    datas.push(item)
                }
                this.datas = datas
            },
            allSelected(items) {
                for (let item of items) {
                    if (!this.selections.findOne({ _id: item._id })) {
                        this.selections.push(item)
                    }
                }
            },
            allSelectedCancel() {
                for (let item of this.datas) {
                    this.selections.remove({ _id: item._id })
                }
            },
            itemSelected(_, item) {
                this.selections.push(item)
            },
            itemSelectedCancel(_, item) {
                this.selections.remove({ _id: item._id })
            },
            showConditions() {
                this.conditionModal = true
            },
            init() {
                let columns = this.options.columns
                if (this.options.exportable === undefined) {
                    this.options.exportable = false
                }
                if (this.options.checkable) {
                    if (!columns.findOne({ type: 'selection' })) {
                        columns.splice(0, 0, { type: 'selection', align: 'center', width: 60, fixed: 'left' })
                    }
                }
                this.columns = columns.filter((item) => {
                    if (item.vif && !item.vif()) return false
                    return true
                })
            },
            async selectAllPage() {
                let res
                if (this.options.load) {
                    res = await this.options.load({
                        query: this.query,
                        fields: this.options.fields,
                        nopage: true,
                    })
                } else {
                    res = await this.$api.post(this.options.api, {
                        query: this.query,
                        fields: this.options.fields,
                        nopage: true,
                    })
                }

                // this.selections = res.data[`${this.options.data.name}s`]
                // for (let item of this.datas) {
                //     item._checked = false
                //     if (this.selections.findOne({ _id: item._id })) {
                //         item._checked = true
                //     }
                // }
                for (let item of res.data[`${this.options.data.name}s`]) {
                    if (!this.selections.findOne({ _id: item._id })) {
                        this.selections.push(item)
                    }
                }
                this.loadData()
            },
            async loadData() {
                this.loading = true
                let res
                if (this.options.load) {
                    res = await this.options.load({
                        query: this.query,
                        page: this.page,
                        fields: this.options.fields,
                        nopage: this.options.nopage,
                    })
                } else {
                    res = await this.$api.post(this.options.api, {
                        query: this.query,
                        page: this.page,
                        fields: this.options.fields,
                        nopage: this.options.nopage,
                    })
                }
                this.loading = false
                this.datas = res.data[`${this.options.data.name}s`]
                for (let data of this.datas) {
                    if (data.createTime) {
                        data.createTimeStr = this.moment(data.createTime).format('MM月DD日 HH:mm')
                    }
                    if (data.lastUpdateTime) {
                        data.lastUpdateTimeStr = this.moment(data.lastUpdateTime).format('MM月DD日 HH:mm')
                    }
                    if (this.selections.findOne({ _id: data._id })) {
                        data._checked = true
                    }
                }
                this.total = res.data.total
                if (this.query.init) {
                    this.query.init = false
                }
                this.$emit('loadData', this.datas)
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            async toExport(scope) {
                let that = this
                let columns_export = []
                let columns
                if (this.options.exportOptions && this.options.exportOptions.loadColumns) {
                    columns = this.options.exportOptions.loadColumns()
                } else {
                    columns = this.options.columns
                }
                for (let i = 0; i < columns.length; i++) {
                    let column = columns[i]
                    if (column.vif && !column.vif()) continue
                    if (column.exportskip) continue
                    if (!column.title) continue
                    if (column.key) {
                        columns_export.push({ title: column.title, key: column.key })
                    } else {
                        columns_export.push({ title: column.title, key: `column_${i}` })
                    }
                }
                let datas_export
                if (this.options.exportOptions && this.options.exportOptions.load) {
                    let r = await this.options.exportOptions.load({ query: this.query, scope, selections: this.selections })
                    datas_export = r.datas
                } else {
                    if (scope == 'all') {
                        let res
                        if (this.options.load) {
                            res = await this.options.load({
                                query: this.query,
                                fields: this.options.fields,
                            })
                        } else {
                            res = await this.$api.post(this.options.api, {
                                query: this.query,
                                fields: this.options.fields,
                            })
                        }
                        datas_export = res.data[`${this.options.data.name}s`]
                    } else if (scope == 'page') {
                        datas_export = this.copy(this.datas)
                    } else if (scope == 'selection') {
                        datas_export = this.copy(this.selections)
                    }
                }
                for (let item of datas_export) {
                    for (let i = 0; i < columns.length; i++) {
                        let column = columns[i]
                        if (column.vif && !column.vif()) continue
                        if (column.exportskip) continue
                        if (!column.title) continue
                        const columns_export_item = columns_export.findOne({ title: column.title })
                        if (!columns_export_item) continue
                        if (column.exporter) {
                            item[columns_export_item.key] = column.exporter(item)
                        } else if (column.render) {
                            column.render(
                                (...values) => {
                                    item[columns_export_item.key] = values[values.length - 1]
                                },
                                { row: item },
                            )
                        } else {
                            item[columns_export_item.key] = item[columns_export_item.key]
                        }
                    }
                    for (let key of Object.keys(item)) {
                        if (typeof item[key] == 'string') {
                            item[key] = '"' + item[key] + '"'
                        }
                    }
                }
                // 记录风险操作 - 如果配置了exportOptions.recordRiskOperation，则记录导出操作
                if (this.options.exportOptions && this.options.exportOptions.recordRiskOperation) {
                    const recordConfig = this.options.exportOptions.recordRiskOperation
                    const type = recordConfig.type || (this.options.title || '数据') + '导出'
                    const pageQuery = recordConfig.pageQuery || (this.query && this.query.riqi ? { riqi: this.query.riqi, riqitype: this.query.riqitype } : {})
                    this.$api.post('/admin/xtsj/fxcz/record', {
                        queryInfo: JSON.stringify({ type: type, query: this.query }),
                        dataCount: datas_export.length,
                        pageQuery: pageQuery
                    }).catch(() => {})
                }
                setTimeout(() => {
                    let append = 0
                    if (datas_export.length > 1) {
                        append = this.moment().format('YYYYMMDDHHmmss')
                    }
                    that.$refs.sheet.exportCsv({
                        filename: `${this.options.title || ''}数据导出_${append}`,
                        columns: columns_export,
                        data: datas_export,
                    })
                }, 200)
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/common/TablePage.vue?14544460